"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TablePaginationModel {
    constructor(length = 10, index = 0, totalLength = 0) {
        this.length = length;
        this.index = index;
        this.totalLength = totalLength;
        this.minCount = 1;
    }
    get maxCount() {
        return Math.ceil(this.totalLength / this.length);
    }
    get offset() {
        return this.length * this.index;
    }
    set offset(value) {
        this.index = Math.floor(value / this.length);
    }
    get displayIndex() {
        return this.index + 1;
    }
    set displayIndex(value) {
        this.index = value - 1;
    }
    get args() {
        return [this.length, this.index, this.totalLength];
    }
}
exports.TablePaginationModel = TablePaginationModel;
//# sourceMappingURL=TablePaginationModel.js.map